module.exports = __webpack_public_path__ + "assets/img/2804.b811ad34.svg";